export default {
  INIT_STATE: Symbol('INIT_STATE'),
  UPDATE_GOODS_STATE: Symbol('UPDATE_GOODS_STATE'),
  GOODS_LIST: Symbol('GOODS_LIST'),
  ADD_GOODS_TO_CART: Symbol('ADD_GOODS_TO_CART'),
  CLIENT_LIST: Symbol('CLIENT_LIST'),
  UPDATE_BUY_WAY: Symbol('UPDATE_BUY_WAY'),
  GET_ORDER_DETAIL: Symbol('GET_ORDER_DETAIL'),
  UPDATE_SEARCH_PARAM: Symbol('UPDATE_SEARCH_PARAM'),
  GET_STORAGE_CONFIG: Symbol('GET_STORAGE_CONFIG'),
};
